
import { Options, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { formatInputByCountry } from "@/app/infrastructures/misc/Utils";

@Options({
  emits: ["update:modelValue", "change", "update:weight"],
  props: {
    weight: {
      default: 0,
      type: Number
    },
    placeholder: {
      default: "0",
      type: String
    },
    adornment: {
      default: "Kg",
      type: String
    },
    position: {
      default: "right", // left or right
      type: String
    },
    maxLength: {
      default: 255,
      type: Number
    },
    errorCaption: {
      default: "",
      type: String
    },
    caption: {
      default: "",
      type: String
    },
    isError: {
      default: false,
      type: Boolean
    },
    dataTestid: {
      default: "",
      type: String
    }
  }
})
export default class InputAdornment extends Vue {
  props: any = this.$props;
  onChange(e: any) {
    const value = formatInputByCountry(e.target.value, {
      type: "weight",
      country: this.countryCode
    });

    this.$emit("change", value);
    this.$emit("update:weight", value);
  }

  get countryCode() {
    const code = AccountController.accountData?.countryCode;
    return code?.toUpperCase() ?? "ID";
  }
  get weightValue() {
    return this.props.weight.toString();
  }
}
